import { render } from "./IconTiktok.vue?vue&type=template&id=6546ce7d"
import script from "./IconTiktok.vue?vue&type=script&lang=js"
export * from "./IconTiktok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__